import { gql } from '@apollo/client';

export const validateForgotPassword_Name = 'ValidateForgotPassword';
export const validateForgotPassword_Gql = gql`
  mutation ValidateForgotPassword($code: String!, $password: String!) {
    validateForgotPassword(code: $code, password: $password) {
      isSuccess
      codeExpired
      message
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
